/**
 * @file 加盟員検索モーダルのインスタンスを生成
 */

'use strict'

/**
 * @classname MemberSearchModal
 * @classdesc 加盟員検索モーダルのインスタンスを生成
 */
export default class MemberSearchModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#modal-member-search')
	 */
	constructor($e) {
		console.log(`MemberSearchModal.constructor`)
		this._$e = $e
		this._element = document.getElementById('modal-member-search')
		this._isDefaultShow = $(this._element).data('is-default-show')
		this._Modal = new bootstrap.Modal(this._element)
		this.initialize()
	}


	/**
	 * Initialize
	 *
	 * @memberof MemberSearchModal
	 * @return {undefined}
	 */
	initialize() {
		console.log(`MemberSearchModal.initialize`)
		if (this._isDefaultShow) this._Modal.show()
	}
}
